import React from 'react';
import { advantages } from '../mock';
import { Target, Award, Globe, CheckCircle, Lock, Users } from 'lucide-react';

const iconMap = {
  Target: Target,
  Award: Award,
  Globe: Globe,
  CheckCircle: CheckCircle,
  Lock: Lock,
  Users: Users
};

const AdvantagesSection = () => {
  return (
    <section className="advantages-section">
      <div className="section-container">
        <div className="section-header centered">
          <h2 className="section-title">Почему выбирают нас</h2>
          <p className="section-subtitle">
            Наши ключевые преимущества и гарантии
          </p>
        </div>

        <div className="advantages-grid">
          {advantages.map((advantage, index) => {
            const IconComponent = iconMap[advantage.icon];
            return (
              <div key={index} className="advantage-card">
                <IconComponent size={48} className="advantage-icon" />
                <h3 className="advantage-title">{advantage.title}</h3>
                <p className="advantage-description">{advantage.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AdvantagesSection;